import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import g from "./iconfont.es5471.js";
const d = {
  display: "block"
}, x = ({ size: e = 16, useVw: n, useRem: o, color: c, withColor: l, removeClassName: t, disableSSR: m, style: r, ...p }) => {
  const h = r ? { ...d, ...r } : d;
  return /* @__PURE__ */ a.createElement(g, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-mingwendaohang", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), height: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: h, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-é­æå¯¼èª"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: l ? i(c, 0, "#262933") : "#262933",
        datafollowfill: l ? i(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M4.9 16C4.9 10.422 9.422 5.9 15 5.9c5.578 0 10.1 4.522 10.1 10.1a.9.9 0 0 0 1.8 0c0-6.572-5.328-11.9-11.9-11.9S3.1 9.428 3.1 16 8.428 27.9 15 27.9a.9.9 0 0 0 0-1.8C9.422 26.1 4.9 21.578 4.9 16Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M13.285 12.464a4.323 4.323 0 0 1 4.209 1 4.323 4.323 0 0 1 1.24 4.144.9.9 0 0 0 1.752.414 6.123 6.123 0 0 0-1.756-5.868 6.123 6.123 0 0 0-5.96-1.415.9.9 0 1 0 .515 1.725Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M16.481 14.38a.9.9 0 0 1 .055 1.271l-4.47 4.877a.9.9 0 1 1-1.327-1.217l4.47-4.876a.9.9 0 0 1 1.272-.056ZM21.5 20.2a.9.9 0 1 0 0 1.8H27a.9.9 0 0 0 0-1.8h-5.5Zm-2.4 3.9a.9.9 0 0 1 .9-.9h7a.9.9 0 1 1 0 1.8h-7a.9.9 0 0 1-.9-.9Zm.9 2.1a.9.9 0 1 0 0 1.8h7a.9.9 0 0 0 0-1.8h-7Z"
        }
      )
    )
  )));
}, w = x;
export {
  w as default
};
